/**
 * Editorial value-review hold for the 29 legacy articles audited on 2026-09-25.
 * This is an explicit ID cohort, not an automatic word-count or Google policy rule.
 * Keep articles and citations available at their original permalinks while editors
 * review substantive value. Remove an ID only after that article is reviewed.
 */
export const ARTICLE_QUALITY_HOLD_IDS = [
  '4f96081cb0abd0aa3cc1',
  'db8b89a9123d00811a35',
  'a5d8a7285c48a080276a',
  '1ab1beb2bb4f097ccbcf',
  '579cd2d25256a511630b',
  '5f7fca2b9b88031543a4',
  '556ab4838fcf4eaef34d',
  '724cc31408c0f3f5264a',
  '12adff364d8ab14d2dc0',
  '276ad4f071a4461f5f76',
  'b27808b31f86a5492c0b',
  '140b33072945569cd756',
  'db452b2d6dca1766f59f',
  '7cdd5816ac2d34e90d75',
  'b59ffb5c3b0fd572967c',
  'd99611906564a02d3b23',
  'f01aa4091c89a5c5d046',
  'ef8387bfe614a448a5ee',
  '2c5f1e8e70d87c2a5f76',
  '6ed5714c752c233665ba',
  '220b6f5dbb6cb6019e98',
  'c7b5b6ee5e52f3fe6ba7',
  'df67b7e285b18947d89a',
  '902ec6f04bb6ef1fe094',
  '438401d43a0101612cad',
  '5862d11bf0fe355d95b1',
  '4f0926b229590cf4687f',
  'c296c39ded7b1e6664f4',
  'a71e09a3a957fe78469a',
] as const

const qualityHoldIds = new Set<string>(ARTICLE_QUALITY_HOLD_IDS)

export function isArticleQualityHeld(id: string): boolean {
  return qualityHoldIds.has(id)
}

const robotsMeta = (name: 'robots' | 'googlebot'): string => `<meta name="${name}" content="noindex,follow" />`

/** Shared by the static Hosting build and dynamic article fallback. */
export function applyArticleQualityHoldHtml(html: string, id: string): string {
  if (!isArticleQualityHeld(id)) return html

  let heldHtml = html
  for (const name of ['robots', 'googlebot'] as const) {
    const tag = new RegExp(`<meta\\b(?=[^>]*\\bname=["']${name}["'])[^>]*>`, 'i')
    heldHtml = tag.test(heldHtml)
      ? heldHtml.replace(tag, robotsMeta(name))
      : heldHtml.replace('</head>', `  ${robotsMeta(name)}\n</head>`)
  }
  heldHtml = heldHtml.replace(/[ \t]*<meta\b(?=[^>]*\bname=["']omikina-article-quality-hold["'])[^>]*>\s*/gi, '')
  heldHtml = heldHtml.replace('</head>', '  <meta name="omikina-article-quality-hold" content="true" />\n</head>')
  return heldHtml.replace(/^[ \t]*<script\b(?=[^>]*\bsrc=["']https:\/\/pagead2\.googlesyndication\.com\/pagead\/js\/adsbygoogle\.js(?:\?[^"']*)?["'])[^>]*>\s*<\/script>[ \t]*\r?\n?/gim, '')
}
